import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import "./Cancel_Reason_Modal.css";
import Pink_Btn from "../../common_btn/pink_btn/Pink_Btn";
import Light_Black_Btn from "../../common_btn/light_black_btn/Light_Black_Btn";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Successfull_Modal from "../../modals/common-modal/successfull_modal/Successfull_Modal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RoomCancelReasons } from "../../../../features/admin/common/Slice";
import { useForm } from "react-hook-form";
import { CancelBooking } from "../../../../features/admin/room/slice";

const Guest_room_cancel_modal = ({ getBookingDetails, ...props }) => {
    const { show, onHide, modal_title, booking_id } = props;
    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors }
    } = useForm();
    const reason = [
        "I changed my plan",
        "I want to book other guest house",
        "Other (please tell us a reason)",
    ];

    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [selectedReason, setSelectedReason] = useState('');
    const [customReason, setCustomReason] = useState('');

    const handleSubmitFo = async (data) => {

        const sendData = new FormData();

        if (data.cancel_reason_id === "other") {
        } else {
            sendData.append("cancel_reason_id", data?.cancel_reason_id);
        }
        sendData.append("cancel_reason_text", data.custom_reason);

        console.log(data);
        for (let pair of sendData.entries()) {
            console.log(pair[0], pair[1]);
        }

        const res = await dispatch(CancelBooking({ id: booking_id, data: sendData }));

        if (res.meta?.requestStatus === "fulfilled") {
            setShowSuccessModal(true);
            props.onHide();
            setTimeout(() => {
                setShowSuccessModal(false);
            }, 2000);
            await getBookingDetails(booking_id)
        }
        else if (res.meta?.requestStatus === "rejected") {

        }

        // setShowSuccessModal(true);

        // props.onHide();

        // setTimeout(() => {
        //     setShowSuccessModal(false);
        // }, 2000);
    };


    const navigate = useNavigate();
    const dispatch = useDispatch();

    const reasonsFromApi = useSelector(
        (state) => state.common.room_cancel_reasons
    );

    const reasons = [
        ...(reasonsFromApi || []),
        {
            id: "other",
            name: "Other (please tell us a reason)"
        }
    ];
    const selectedReasonId = watch("cancel_reason_id");

    const isOtherSelected = selectedReasonId === "other";

    useEffect(() => {
        dispatch(RoomCancelReasons());
    }, [dispatch])

    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                size="lg"
                className="Cancel_Reason_Modal Modal-holder common_modal"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {modal_title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="select_reason">
                        <Form>
                            {reasons.map((reason) => (
                                <Form.Check
                                    key={reason.id}
                                    type="radio"
                                    label={reason.name}
                                    value={reason.id}
                                    className="mini-text"
                                    {...register("cancel_reason_id", {
                                        required: "Please select a reason"
                                    })}
                                />
                            ))}


                            {errors.cancel_reason_id && (
                                <p className="text-danger mt-2">
                                    {errors.cancel_reason_id.message}
                                </p>
                            )}

                            <div className="addresonsec mt-3">
                                <FloatingLabel
                                    controlId="floatingTextarea"
                                    label="Could you tell us a reason for cancelling?"
                                >
                                    <Form.Control
                                        as="textarea"
                                        placeholder="Enter reason"
                                        // disabled={!isOtherSelected}
                                        {...register("custom_reason", {
                                            validate: (value) => {
                                                if (isOtherSelected && !value?.trim()) {
                                                    return "Please enter a cancellation reason";
                                                }
                                                return true;
                                            }
                                        })}
                                    />
                                </FloatingLabel>


                                <div className="row justify-content-center mt-4">
                                    <div className="col-md-3 col-5">
                                        <Light_Black_Btn btnText={'Cancel'} onClick={onHide} />
                                    </div>
                                    <div className="col-md-3 col-5">
                                        <Pink_Btn btnText={'Submit'} onClick={handleSubmit(handleSubmitFo)} />
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>

            <Successfull_Modal
                show={showSuccessModal}
                onHide={() => setShowSuccessModal(false)}
                headtext={'Guest House Booking Cancelation'}
                successfultext={'Booking Cancelled Successfully!'}
                subtext={'See You Soon!'}
                subtext2={'Have a nice time ahead'}
            />
        </>
    );
};

export default Guest_room_cancel_modal;
